export const VERSION = "0.16.3-SNAPSHOT";
